import { render, staticRenderFns } from "./UserTrendScatter.vue?vue&type=template&id=61ad2bec&scoped=true"
import script from "./UserTrendScatter.vue?vue&type=script&lang=ts"
export * from "./UserTrendScatter.vue?vue&type=script&lang=ts"
import style0 from "./UserTrendScatter.vue?vue&type=style&index=0&id=61ad2bec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ad2bec",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/user-trend/user-trend-scatter.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fuser-trend%2Fscatter%2FUserTrendScatter.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports